<template>
  <v-app>
    <template v-if="loadingApp">
      <Loading />
    </template>
    <template v-else>
      <template v-if="usuarioLogado">
        <template v-if="pendencias">
          <!-- 
          ========================================
          QUESTIONÁRIO DE DESLIGAMENTO DESABILITADO
          ========================================
          Solicitação do RH - ID-2440
          Motivo: Desabilitar temporariamente o questionário de desligamento
          
          Código original comentado abaixo:
          -->
          <!-- 
          <questionario-desligamento
            v-if="shouldShowQuestionarioDesligamento"
          />
          -->

          <!-- Outras pendências (sem verificação de questionário) -->
          <dialog-atualizar-dados-pessoais
            v-if="pendencias.atualizar_dados_pessoais"
          />
          <docs-pendentes-ciencia
            v-else-if="pendencias.documentos.length > 0"
          />
        </template>
        <Header />
        <Menu />
        <Conteudo />
        <Footer />
      </template>
      <template v-else>
        <Auth />
      </template>
    </template>
  </v-app>
</template>

<script>
import Header from "@/template/Header";
import Conteudo from "@/template/Conteudo";
import Footer from "@/template/Footer";
import Menu from "@/template/Menu";
import Auth from "@/views/auth/Auth";
import Loading from "@/template/Loading";

import { mapState, mapGetters } from "vuex";
import DocsPendentesCiencia from "./views/pendencias/DocsPendentesCiencia.vue";
import DialogAtualizarDadosPessoais from "./views/pendencias/DialogAtualizarDadosPessoais.vue";
// import QuestionarioDesligamento from "./views/questionario-desligamento/QuestionarioDesligamento.vue";

export default {
  name: "App",
  computed: {
    ...mapState("usuario", ["usuarioLogado", "loadingApp", "pendencias"]),
    ...mapGetters("usuario", ["shouldShowQuestionarioDesligamento"]),
  },
  components: {
    Header,
    Conteudo,
    Footer,
    Menu,
    Auth,
    Loading,
    DocsPendentesCiencia,
    DialogAtualizarDadosPessoais,
    // QuestionarioDesligamento,
  },
  data: () => ({}),
  isMobile() {
    return this.$mq == "sm";
  },
};
</script>

<style>
* {
  text-transform: none !important;
  font-family: "Poppins", sans-serif !important;
}

.primary--text {
  color: #1b5e20 !important;
}

.h-100 {
  height: 100% !important;
}

.h-95 {
  height: 95% !important;
}

.flexcard {
  display: flex;
  flex-direction: column;
}

.toasted {
  font-size: 1.1rem !important;
}

.v-card__title {
  word-break: unset;
}
</style>
